










































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import SearchCustomerPersonalInput from "@/views/search/search-modal-customer/search-modal-customer-personal-input.vue";
import { UserModule } from "@/store/modules/User";
import CustomerModel from "@/models/CustomerModel";

@Component({
    components: { SearchCustomerPersonalInput }
})
export default class SearchCustomerInformationComponent extends Vue {
    @Prop()
    isEditing!: boolean;

    @Prop()
    customer!: any;

    @Prop()
    isLoading!: boolean;

    @Prop()
    loadingDetails!: boolean;

    get isPerson() {
        return CustomerModel.isPerson(this.customer.info.customerType);
    }

    get isCompany() {
        return CustomerModel.isCompany(this.customer.info.customerType);
    }

    get userType() {
        return UserModule.userType;
    }
}
